import RequireAuth from '@Components/Utility/RequireAuth'
import React from 'react'
import SongwriterLayout from '@Scenes/SongwriterScene/SongwriterLayout'
import SongwriterCatalogBuilderScene from '@Scenes/SongwriterScene/SongwriterCatalogBuilderScene'
import SongwriterCatalogScene from '@Scenes/SongwriterScene/SongwriterCatalogScene'
import ViewWorkSongwriterScene from '@Scenes/WorkScenes/ViewWorkSongwriterScene'
import SongwriterCatalogLayout from '@Scenes/SongwriterScene/SongwriterCatalogLayout'
import SongwriterMyWritersScene from '@Scenes/SongwriterScene/SongwriterMyWritersScene'
import SongwriterViewSearchedWorkScene from '@Scenes/SongwriterScene/SongwriterViewSearchedWorkScene'
import SongwriterWorkShareUpdateRequestScene from '@Scenes/SongwriterScene/SongwriterWorkShareUpdateRequestScene'
import { SONGWRITER_ROUTE_WITH_ID, SONGWRITER_SUB_ROUTES } from '@App/navigation/route'
import CowriterSearchScene from '@Scenes/SongwriterScene/CowriterSearch/CowriterSearchScene'
import MatchScene from '@Scenes/RightsholderScene/MatchClaim/Match'
import MatchHistoryLayout from '@Scenes/RightsholderScene/MatchHistory/v2/MatchHistoryLayout'
import MatchHistorySearch from '@Scenes/RightsholderScene/MatchHistory/v2/MatchHistorySearch'
import MatchHistoryViewRecordingGroups from '@Scenes/RightsholderScene/MatchHistory/v2/MatchHistoryViewRecordingGroups'

const createSongwriterRoutes = () => ({
    path: SONGWRITER_ROUTE_WITH_ID,
    element: (
        <RequireAuth>
            <SongwriterLayout />
        </RequireAuth>
    ),
    children: [
        {
            path: SONGWRITER_SUB_ROUTES.link,
            element: <SongwriterCatalogBuilderScene />,
        },
        {
            path: SONGWRITER_SUB_ROUTES.myWriters,
            element: <SongwriterMyWritersScene />,
        },
        {
            path: SONGWRITER_SUB_ROUTES.searchedWork,
            element: <SongwriterViewSearchedWorkScene />,
        },
        {
            path: SONGWRITER_SUB_ROUTES.searchedWork,
            element: <SongwriterViewSearchedWorkScene />,
        },
        {
            path: SONGWRITER_SUB_ROUTES.cowriters.root,
            element: <CowriterSearchScene />,
            children: [
                {
                    path: SONGWRITER_SUB_ROUTES.cowriters.search,
                    element: <CowriterSearchScene />,
                },
            ],
        },
        {
            path: '',
            element: <SongwriterCatalogLayout />,
            children: [
                {
                    path: SONGWRITER_SUB_ROUTES.catalog.root,
                    element: <SongwriterCatalogScene />,
                },
                {
                    path: SONGWRITER_SUB_ROUTES.catalog.viewWork,
                    element: <ViewWorkSongwriterScene />,
                },
                {
                    path: SONGWRITER_SUB_ROUTES.catalog.requestUpdateShares,
                    element: <SongwriterWorkShareUpdateRequestScene />,
                },
            ],
        },
        {
            path: SONGWRITER_SUB_ROUTES.matchingTool,
            element: <MatchScene />,
        },
        {
            path: '',
            element: <MatchHistoryLayout />,
            children: [
                {
                    path: SONGWRITER_SUB_ROUTES.matchHistory.root,
                    element: <MatchHistorySearch />,
                },
                {
                    path: SONGWRITER_SUB_ROUTES.matchHistory.submission,
                    element: <MatchHistoryViewRecordingGroups />,
                },
            ],
        },
    ],
})

export default createSongwriterRoutes
